export {
  default,
  default as useManageServiceTeamsTable,
} from "./useManageServiceTeamsTable";
